import React from 'react';
import { Link } from 'react-router-dom';
import Box, { BoxProps } from 'ui-box';
import { defaultColors } from '../../npaper/Colors';
import { ICompany } from '../../stores/contacts/CompanyStore';

export interface ICompanyThumbnailProps extends BoxProps<'div'> {
  children?: never;
  showName?: boolean;
  company: ICompany;
  noLink?: boolean;
}

export const CompanyThumbnail: React.FC<ICompanyThumbnailProps> = ({
  showName = true,
  company,
  noLink = false,
  ...props
}) => {
  return (
    <Box {...props} display="flex" alignItems="center">
      <Box
        width="32px"
        height="32px"
        backgroundColor={defaultColors.gray[100]}
        display="flex"
        alignItems="center"
        justifyContent="center"
        fontSize={12}
        borderRadius={3}
        flexShrink={0}
        overflow="hidden"
        marginRight={showName ? 8 : 0}
      >
        {company.logo_icon ? (
          <img
            src={company.logo_icon.medium}
            alt={company.initials}
            style={{
              objectFit: 'contain',
              width: '100%',
              height: '100%',
              padding: '4px',
            }}
          />
        ) : (
          company.initials
        )}
      </Box>
      {showName && (
        <Link className="p a elipsis" to={`/companies/${company.id}`}>
          {company.name}
        </Link>
      )}
    </Box>
  );
};
